import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import { getFullReport } from '../../dummy-data/DUMMYDATA'
import Loading from '../Loading'
// import { ReadingsTable } from './ReadingsTable'
import { ReadingsTable } from '../shared/ReadingsTable'
// import BigNumbers from './BigNumbers'
import BigNumbers from '../shared/BigNumbers'
import ReportTitle from './ReportTitle'
import { isReportIssuer } from '../../api/auth'
import ReportCharts from './ReportCharts'
import { downloadTextFile, exportCsv, readingsToCsv } from '../../utils/utils'
import moment from 'moment'

export default class MonthlyReport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      report: undefined,
      reportMonth: undefined,
    }
  }

  componentDidMount() {
    getFullReport(this.props.match.params.reportId)
      .then((res) => {
        for (let index = 0; index < res.readings.length; index++) {
          res.readings[index].opDt = moment(res.readings[index].opDt)
        }

        this.setState({
          report: res,
          reportMonth: moment(`${res.year}-${String(res.month + 1).padStart(2, '0')}-01 00:00:00`).format('MMMM'),
        })
      })
      .catch((err) => {
        this.setState({ report: null })
      })
  }

  // exploreReadings = () => {
  //   const rp = this.state.report
  //   console.log(rp)
  //   // Setup query params
  //   const filters = {
  //     fromDt: moment()
  //   }
  // }

  exportCsv = () => {
    if (this.state.report && this.state.report.readings.length > 0) {
      let csv = readingsToCsv(this.state.report.readings)

      const fileName = `RelatórioGeral_${this.state.reportMonth}_${this.state.report.year}.csv`

      downloadTextFile(fileName, csv)
    }
  }

  render() {
    const rp = this.state.report

    const isPrint = false

    if (!rp) {
      return (
        <div className="mt-6 ml-6">
          <Loading />
        </div>
      )
    }

    return (
      <div style={{ backgroundColor: isPrint ? 'white' : '#f3f3f0' }}>
        <div className="container">
          {/* TITLE */}
          <section className="section">
            <nav className="level">
              <div className="level-left">
                <ReportTitle report={rp} />
              </div>

              <div className="level-right">
                {!isPrint && (
                  <div className="field is-grouped has-addons">
                    <p className="control">
                      {isReportIssuer() &&
                        !rp.isReportGroup &&
                        (rp.publishedAt ? (
                          <button className="button is-success">
                            <span className="icon is-small">
                              <FontAwesomeIcon icon="eye" />
                            </span>
                            <span>Publicado</span>
                          </button>
                        ) : (
                          <button className="button is-warning">
                            <span className="icon is-small">
                              <FontAwesomeIcon icon="bullhorn" />
                            </span>
                            <span>Publicar</span>
                          </button>
                        ))}
                    </p>
                    <p className="control">
                      <button className="button is-primary">
                        <span className="icon is-small">
                          <FontAwesomeIcon icon="file-pdf" />
                        </span>
                        <span>Exportar para PDF</span>
                      </button>
                    </p>
                    {/* <p className="control">
                    <button className="button is-primary" onClick={this.exportCsv}>
                      <span className="icon is-small">
                        <FontAwesomeIcon icon='file-csv'/>
                      </span>
                      <span>Exportar para CSV</span>
                    </button>
                  </p> */}
                    {/* <p className="control">
                    <button className="button is-primary" onClick={this.exploreReadings}>
                      <span className="icon is-small">
                        <FontAwesomeIcon icon='search'/>
                      </span>
                      <span>Explorar Leituras</span>
                    </button>
                  </p> */}
                  </div>
                )}
              </div>
            </nav>
          </section>

          {/* BIG NUMBERS */}
          {/* <BigNumbers report={rp} isPrint={isPrint}/> */}
          <BigNumbers report={rp} isPrint={isPrint} title={'Resumo Mensal'} />

          {/* CHARTS */}

          <ReportCharts report={rp} isPrint={isPrint} />

          {/* READINGS */}

          <ReadingsTable
            operatorName={rp.operatorName}
            readings={rp.readings}
            isPrint={isPrint}
            exportCsv={this.exportCsv}
          />
        </div>
      </div>
    )
  }
}
